import { useEffect, useRef, useState } from 'react';
import { useStore } from '../../../utils/store';
import { useNavigate, useParams } from 'react-router-dom';
import IdLabelData from '../../../Models/IdLabelData';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import Grid from '@mui/material/Grid2';
import TextFieldComponent from '../../../components/form/TextFieldComponent';
import SelectFieldComponent from '../../../components/form/SelectFieldComponent';
import TextFieldAreaComponent from '../../../components/form/TextFieldAreaComponent';
import { Button, Stack } from '@mui/material';
import FormFieldData from '../../../Models/FormFieldData';
import CommonForm from '../../../components/form/CommonForm';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import { AddCircleOutline, HighlightOff } from '@mui/icons-material';
import {
  formatPrice,
  getCurrentDate,
  handleErrorMessage,
} from '../../../utils/storageUtil';
import DragAndDropFileUploadWithBrowse from '../../../components/FileUploadComponentWithBrowse';
import { useAlert } from '../../../components/alertContext';

const ResourcesForm: React.FC = () => {
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();
  const { currentId } = useParams<{ currentId: any }>();
  const navigate = useNavigate();

  const [primaryError, setPrimaryError] = useState<boolean>(false);
  const [isContractorProgress, setIsContractorProgress] =
    useState<boolean>(false);
  const [s3FilesProductUpdate, setS3FilesProductUpdate] = useState<any>([]);
  const [s3FilesCommercialUpdate, setS3FilesCommercialUpdate] = useState<any>(
    []
  );
  const [s3FilesProduct, setS3FilesProduct] = useState<any>([]);
  const [s3FilesCommercial, setS3FilesCommercial] = useState<any>([]);
  const [s3FilesQuotes, setS3FilesQuotes] = useState<any>([]);
  const [s3FilesQuotesUpdate, setS3FilesQuotesUpdate] = useState<any>([]);
  const [deletedQuoteFiles, setDeletedQuoteFiles] = useState<any>([]);
  const [selectedPrimary, setSelectedPrimary] = useState<any>(null);

  const [totalQuotes, setTotalQuotes] = useState<number>(3);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [contractorList, setContractorList] = useState<IdLabelData[]>([]);
  const [resourceTypesList, setResourceTypesList] = useState<IdLabelData[]>([]);
  const [unitType, setUnitType] = useState<IdLabelData[]>([]);
  const [billableItems, setBillableItems] = useState<IdLabelData[]>([]);
  const [resourceDetailForm, setResourceDetailForm] = useState<any>({});

  interface resourceFormFields {
    name: string;
    unitTypeId: string;
    billables: any;
    id?: string | null;
    price: string;

    contractorId: string;
    notes: string;
    reorderPoint: string;
    expiryDate: string;
    resourceTypeId: string;
    isQuote: boolean;
  }
  const [resourceForm, setResourceForm] = useState<resourceFormFields>({
    name: '',
    unitTypeId: '',
    billables: null,
    id: null,
    notes: '',
    price: '0.00',
    contractorId: '',
    expiryDate: getCurrentDate(),
    isQuote: false,
    resourceTypeId: '',
    reorderPoint: '',
  });

  const fetchBillables = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.billableURL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { search: '', limit: -1, offset: 0 }
      );
      if (response.success) {
        setBillableItems(response.data);
      } else {
      }
      console.log('GET Response:', response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchResourceTypes = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.refBundleURL + '/fetchResourceTypes',
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { search: '', limit: -1, offset: 0 }
      );
      if (response.success) {
        setResourceTypesList([
          { id: '', label: 'Select Resource Type' },
          ...response.data,
        ]);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const fetchUnitTypes = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.refBundleURL + '/fetchUnitTypes',
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { search: '', limit: -1, offset: 0 }
      );
      if (response.data) {
        setUnitType([{ id: '', label: 'Select Unit Type' }, ...response.data]);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const fetchContractors = async () => {
    try {
      if (isContractorProgress === false) {
        setIsContractorProgress(true);
        const response = await HttpService.get(
          Constants.apiURL + Constants.contractorsURL,
          { headers: { Authorization: 'Bearer ' + getAdmin() } },
          { search: '', limit: -1, offset: 0 }
        );
        if (response.success) {
          setContractorList([
            { id: '', label: 'Select Contractor' }, // Default option
            ...response.data.paginateRecords.map((item: any) => ({
              id: item.id,
              label: item.name,
            })),
          ]);
          setIsContractorProgress(false);
        }
        console.log('GET Response:', response);
      }
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const CreateOrUpdate = async (formData: any) => {
    return new Promise(async (resolve) => {
      try {
        let response: any = null;
        if (formData['id']) {
          response = await HttpService.put(
            Constants.apiURL + Constants.resourcesURL,
            formData,
            { headers: { Authorization: 'Bearer ' + getAdmin() } }
          );
        } else {
          response = await HttpService.post(
            Constants.apiURL + Constants.resourcesURL,
            formData,
            { headers: { Authorization: 'Bearer ' + getAdmin() } }
          );
        }

        if (response.success) {
          resolve(response);
          // fetchData();
          // clearForm(false);
        } else {
          return resolve(null);
        }
        console.log('GET Response:', response);
      } catch (error: any) {
        console.error(`PATCH Error:`, error);
        setAlert({
          type: 'error',
          message: handleErrorMessage(error),
          open: true,
        });
        setLoading(false);
        return resolve(null);
      }
    });
  };

  const getResourceRecord = async (id: any) => {
    return new Promise(async (resolve, reject) => {
      const response = await HttpService.get(
        Constants.apiURL + Constants.resourcesURL + '/' + id,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        null
      );
      if (response.success) {
        resolve(response.data);
      } else {
        resolve(null);
      }
    });
  };

  const handleRowClick = async (record: any) => {
    setCurrentRecord(record);
    if (currentId) {
      setResourceForm({
        name: record.name,
        unitTypeId: record.unitTypeId,
        billables: record.billable,
        id: record.id,
        notes: record.notes,
        price: formatPrice(record.price),
        contractorId: record.contractorId,
        expiryDate: record.expiryDate,
        reorderPoint: record.reorderPoint,
        resourceTypeId: record.resourceTypeId,
        isQuote: record.isQuote === '1' ? true : false,
      });

      if (record.isQuote === '0') {
        if (record.details[0].media.length > 0) {
          setS3FilesCommercialUpdate(
            record.details[0].media.filter(
              (mediaData: any) =>
                mediaData.relationType === 'resource_commercial'
            )
          );
          setS3FilesProductUpdate(
            record.details[0].media.filter(
              (mediaData: any) => mediaData.relationType === 'resource_product'
            )
          );
        }
      }
      if (record.isQuote === '1') {
        const totalDetailsRecords = record.details;
        setTotalQuotes(totalDetailsRecords.length);
        const detailResources: any = {};
        const mediaRecords: any = [];
        for (let i = 0; i < totalDetailsRecords.length; i++) {
          mediaRecords[i] = [];
          detailResources['price' + i] = totalDetailsRecords[i].price;
          detailResources['contractorId' + i] =
            totalDetailsRecords[i].contractorId;
          detailResources['notes' + i] = totalDetailsRecords[i].notes;
          detailResources['id' + i] = totalDetailsRecords[i].id;
          mediaRecords[i] = totalDetailsRecords[i].media;
          if (totalDetailsRecords[i].isPrimary === '1') {
            setSelectedPrimary(i);
          }
        }
        // console.log(`mediaRecords`);
        // console.log(mediaRecords);
        // console.log(`mediaRecords`);
        setS3FilesQuotesUpdate(mediaRecords);
        setResourceDetailForm(detailResources);
      }
    }
  };

  const fetchSingleRecord = async (id: any) => {
    try {
      const resource = await getResourceRecord(id);
      if (resource) {
        setCurrentRecord(resource);
        handleRowClick(resource);
      }

      console.log('GET Response:', resource);
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const clearForm = () => {
    setResourceForm({
      name: '',
      unitTypeId: '',
      billables: null,
      id: null,
      notes: '',
      price: '',
      contractorId: '',
      expiryDate: getCurrentDate(),
      isQuote: false,
      resourceTypeId: '',
      reorderPoint: '',
    });
    setCurrentRecord(null);
    setS3FilesCommercial([]);
    setS3FilesProduct([]);
    setS3FilesProductUpdate([]);
    setS3FilesCommercialUpdate([]);
    setLoading(false);
    setS3FilesQuotesUpdate([]);
    setS3FilesQuotes([]);
    setDeletedQuoteFiles([]);
    setAlert({
      type: 'error',
      message: '',
      open: false,
    });
    navigate('/data-management/resource-items');
  };

  // TODO: Remove function?
  const handleFileUpload = async (
    file: any,
    relationType: any,
    relationId: any
  ) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (file) {
          setLoading(true);
          const formData = new FormData();
          formData.append('relationType', relationType);
          formData.append('relationId', relationId);
          formData.append('file', file);
          if (currentRecord) {
            formData.append('id', currentRecord.id);
          }
          const response = await HttpService.postWithFileUpload(
            Constants.apiURL + Constants.mediaURL,
            formData,
            {
              headers: {
                Authorization: 'Bearer ' + getAdmin(),
                'Content-Type': 'multipart/form-data',
              },
            }
          );
          if (response.success) {
            resolve(response.media);
          } else {
            resolve(false);
          }
          console.log('GET Response:', response);
        }
      } catch (error: any) {
        resolve(false);
        console.error(`PATCH Error:`, error);
        setAlert({
          type: 'error',
          message: error.message,
          open: true,
        });
      }
      setLoading(false);
    });
  };

  const convertToStructuredArray = (data: any) => {
    const result: any = [];
    const keys = Object.keys(data);

    // Extract unique indexes (e.g., 0, 1, 2) from the keys
    const indexes = Array.from(
      new Set(keys.map((key) => key.match(/\d+$/)?.[0]))
    );

    // Iterate over each index and group related fields into an object
    indexes.forEach((index: any) => {
      console.log(index, selectedPrimary);
      const isPrimary =
        parseInt(index) === parseInt(selectedPrimary) ? true : false;
      result.push({
        price: data[`price${index}`] || null,
        contractorId: data[`contractorId${index}`] || null,
        notes: data[`notes${index}`] || null,
        isPrimary: isPrimary ? '1' : '0',
        unitTypeId: resourceForm.unitTypeId,
        id: data[`id${index}`] || null,
      });
    });

    return result;
  };

  const handleSaveSpecial = async () => {
    try {
      if (selectedPrimary === null) {
        setPrimaryError(true);
        return false;
      }

      const details = convertToStructuredArray(resourceDetailForm);
      if (details.length === 0) {
        setAlert({
          type: 'error',
          message: 'Contractor price is required',
          open: true,
        });

        return false;
      }
      if (details.length > 0) {
        const errors: string[] = details.flatMap((detailFields: any) => {
          const fieldErrors: string[] = [];

          if (!detailFields.contractorId) {
            fieldErrors.push('Contractor is a required field');
          }
          if (!detailFields.price) {
            fieldErrors.push('Price is a required field');
          }

          return fieldErrors;
        });
        if (errors.length > 0) {
          setAlert({
            type: 'error',
            message: errors.join(','),
            open: true,
          });
          return false;
        }
      }

      // console.log(details);
      // return false;
      const postData: any = {
        name: resourceForm.name,
        isQuote: resourceForm.isQuote ? '1' : '0',
        expiryDate: resourceForm.expiryDate,
        resourceTypeId: resourceForm.resourceTypeId,
        billables: resourceForm.billables,
        details: details,
        reorderPoint: resourceForm.reorderPoint,
        deletedQuoteFiles: deletedQuoteFiles,
        unitTypeId: resourceForm.unitTypeId,
      };
      if (currentRecord) {
        postData['id'] = currentRecord.id;
        const updatedMedia = getUpdatedMediaQuote(details);
        postData['details'] = updatedMedia;
      }
      setLoading(true);
      setPrimaryError(false);
      const resourceData: any = await CreateOrUpdate(postData);

      if (resourceData) {
        if (resourceData.data) {
          console.log(resourceData);
          const detailsData = resourceData.data.details;

          if (totalQuotes > 0 && detailsData.length > 0) {
            for (let i = 0; i < detailsData.length; i++) {
              if (s3FilesQuotes[i]) {
                if (s3FilesQuotes[i].length > 0) {
                  for (let j = 0; j < s3FilesQuotes[i].length; j++) {
                    await HttpService.handlePresignedURL(
                      s3FilesQuotes[i][j],
                      'resource_details',
                      detailsData[i].id,
                      getAdmin()
                    );
                  }
                }
              }
            }
            setLoading(false);
            clearForm();
          }
        } else {
          setLoading(false);
        }
      }
    } catch (error: any) {
      console.error(error);
      setAlert({
        type: 'error',
        message: handleErrorMessage(error),
        open: true,
      });
    }
  };

  const getUpdatedMedia = () => {
    const commercial = currentRecord.details[0].media.filter(
      (mediaData: any) =>
        mediaData.relationType === 'resource_commercial' &&
        s3FilesCommercialUpdate.find((item: any) => item.id === mediaData.id)
    );
    const product = currentRecord.details[0].media.filter(
      (mediaData: any) =>
        mediaData.relationType === 'resource_product' &&
        s3FilesProductUpdate.find((item: any) => item.id === mediaData.id)
    );
    return [...commercial, ...product];
  };
  const getUpdatedMediaQuote = (details: any[]) => {
    const objArr = Object.values(s3FilesQuotesUpdate).flat();
    console.log(JSON.stringify(objArr));
    console.log(JSON.stringify(details));
    const detailsArr: any = details.map((priceItem: any) => ({
      ...priceItem,
      media: objArr.filter(
        (mediaItem: any) => mediaItem.relationId === String(priceItem.id)
      ),
    }));
    return detailsArr;
  };
  const handleSave = async () => {
    // console.log(s3FilesCommercial);
    // console.log(s3FilesProduct);
    // return false;

    setLoading(true);
    const postData: any = {
      name: resourceForm.name,
      isQuote: resourceForm.isQuote ? '1' : '0',
      expiryDate: resourceForm.expiryDate,
      resourceTypeId: resourceForm.resourceTypeId,
      billables: resourceForm.billables,
      unitTypeId: resourceForm.unitTypeId,
      reorderPoint: resourceForm.reorderPoint,
      details: [
        {
          contractorId: resourceForm.contractorId,
          price: resourceForm.price,

          notes: resourceForm.notes,
          isPrimary: '1',
        },
      ],
    };
    if (currentRecord) {
      postData['id'] = currentRecord.id;
      // postData['s3FilesProduct'] = s3FilesProductUpdate;
      // postData['s3FilesCommercial'] = s3FilesCommercialUpdate;
      postData['details'][0]['id'] = currentRecord['details'][0]['id'];

      var mediaMerge: any = getUpdatedMedia();

      postData['details'][0]['media'] = mediaMerge;
    }
    const resourceData: any = await CreateOrUpdate(postData);
    if (resourceData) {
      if (resourceData.data.details.length > 0) {
        if (s3FilesProduct.length > 0) {
          for (let i = 0; i < s3FilesProduct.length; i++) {
            await HttpService.handlePresignedURL(
              s3FilesProduct[i],
              'resource_product',
              resourceData.data.details[0].id,
              getAdmin()
            );
          }
        }
        if (s3FilesCommercial.length > 0) {
          for (let j = 0; j < s3FilesCommercial.length; j++) {
            await HttpService.handlePresignedURL(
              s3FilesCommercial[j],
              'resource_commercial',
              resourceData.data.details[0].id,
              getAdmin()
            );
          }
        }
      }

      clearForm();
      setLoading(false);
    }
  };

  const handleExpiryDate = (value: any) => {
    const expiryDateValue =
      value.year() + '-' + (value.month() + 1) + '-' + value.date();
    setResourceForm((prev: any) => {
      return { ...prev, expiryDate: expiryDateValue };
    });
  };

  const removeQuoteFields = () => {
    setTotalQuotes(totalQuotes - 1);
    setResourceDetailForm((prevData: any) => {
      const updatedData = { ...prevData };
      delete updatedData[`notes${totalQuotes - 1}`];
      delete updatedData[`contractorId${totalQuotes - 1}`];
      delete updatedData[`price${totalQuotes - 1}`];
      return updatedData;
    });
  };

  const handleRemove = async (fileData: any, fileType: any) => {
    // const updatedFiles = uploadFile.filter((file: any) => file !== fileData); // Create a new array
    if (fileType === 'resource_product') {
      setS3FilesProduct(fileData);
    }
    if (fileType === 'resource_commercial') {
      setS3FilesCommercial(fileData);
    }
  };

  const handleRemoveFileUpdate = async (fileData: any, fileType: any) => {
    if (fileType === 'resource_product') {
      const updatedFiles = s3FilesProductUpdate.filter(
        (file: any) => file !== fileData
      ); // Create a new array

      setS3FilesProductUpdate(updatedFiles);
    }
    if (fileType === 'resource_commercial') {
      const updatedFiles = s3FilesCommercialUpdate.filter(
        (file: any) => file !== fileData
      ); // Create a new array
      setS3FilesCommercialUpdate(updatedFiles);
    }
  };

  const handleFileChange = async (file: any, fileType: any) => {
    if (file.length > 0) {
      if (fileType === 'resource_product') {
        console.log(`After resource_product`);
        setS3FilesProduct((prevFiles: any) => [
          ...prevFiles,
          ...Array.from(file),
        ]);
      }
      if (fileType === 'resource_commercial') {
        console.log(`After resource_commercial`);
        setS3FilesCommercial((prevFiles: any) => [
          ...prevFiles,
          ...Array.from(file),
        ]);
      }
    }
  };

  const handleRemoveQuoteUpdate = async (fileData: any, formNumber: any) => {
    const updatedFiles = s3FilesQuotesUpdate[formNumber].filter(
      (file: any) => file !== fileData
    );
    const removedFiles = deletedQuoteFiles;
    if (removedFiles.indexOf(fileData) === -1) {
      removedFiles.push(fileData);
      setDeletedQuoteFiles(removedFiles);
    }
    setS3FilesQuotesUpdate((prev: any) => {
      return { ...prev, [formNumber]: updatedFiles };
    });
  };

  const handleRemoveQuote = async (fileData: any, formNumber: any) => {
    // const updatedFiles = uploadFile.filter((file: any) => file !== fileData); // Create a new array
    setS3FilesQuotes((prev: any) => {
      return { ...prev, [formNumber]: fileData };
    });
  };

  const handleFileQuoteChange = async (file: any, formNumber: any) => {
    setS3FilesQuotes((prev: any) => {
      return { ...prev, [formNumber]: file };
    });
  };

  const handleBillableChange = (e: any, dataValue: any) => {
    setResourceForm((prev: any) => {
      return { ...prev, billables: dataValue };
    });
  };

  const handleInputChange = (e: React.ChangeEvent<any>) => {
    const { name, value, type } = e.target;
    setResourceForm((prev) => {
      if (type === 'checkbox') {
        return { ...prev, [name]: e.target.checked };
      } else {
        return { ...prev, [name]: value };
      }
    });
  };

  const handlePriceChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;
    if (value !== '' && !/^\d*\.?\d{0,5}$/.test(value)) {
      return;
    }
    setResourceForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleInputQuoteChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;
    setResourceDetailForm((prevData: any) => ({
      ...prevData,
      [name]: value, // Update state dynamically
    }));
  };

  const renderQuotes = () => {
    const totalElements: any[] = [];
    for (let i = 0; i < totalQuotes; i++) {
      const formNumber = i;
      totalElements.push(
        <Grid size={4}>
          <Grid
            container
            spacing={2}
            style={{ width: '100%', textAlign: 'left' }}
          >
            <Grid size={12}>
              <TextFieldComponent
                name={'price' + formNumber}
                value={resourceDetailForm['price' + formNumber] || ''}
                isRequired={true}
                errorStr={''}
                keyName={'resourceDetailFormPrice_' + formNumber}
                label="Price"
                onChange={handleInputQuoteChange}
                placeholder=""
              />
            </Grid>
            <Grid size={12}>
              <SelectFieldComponent
                label="Contractor/Supplier"
                name={'contractorId' + formNumber}
                keyName={'resourceDetailFormContractorId_' + formNumber}
                value={resourceDetailForm['contractorId' + formNumber] || ''}
                onChange={(e: any) => {
                  handleInputQuoteChange(e);
                }}
                isRequired={true}
                errorStr={''}
                items={contractorList}
              />
            </Grid>
            <Grid size={12}>
              <DragAndDropFileUploadWithBrowse
                errorStr={''}
                label="Attachments"
                multiple={true}
                isRequired={false}
                keyName={'resourceDetailFormFiles_' + formNumber}
                name={'fileQuoteURL' + formNumber}
                defaultValue={[]}
                isCurrentFiles={
                  resourceForm.id ? s3FilesQuotesUpdate[formNumber] : []
                }
                handleCurrentFilesRemove={(file: any) => {
                  handleRemoveQuoteUpdate(file, formNumber);
                }}
                onChange={(file: any) => {
                  handleFileQuoteChange(file, formNumber);
                }}
                handleRemove={(file: any) => {
                  handleRemoveQuote(file, formNumber);
                }}
                handleOpen={(id) => {
                  HttpService.handleDownloadFile(id, getAdmin());
                }}
              />
            </Grid>
            <Grid size={12}>
              <TextFieldAreaComponent
                label="Notes"
                isRequired={false}
                name={'notes' + formNumber}
                errorStr={''}
                minRows={7}
                onChange={handleInputQuoteChange}
                placeholder="Enter notes"
                keyName={'resourceDetailFormNotes_' + formNumber}
                value={resourceDetailForm['notes' + formNumber] || ''}
              />
            </Grid>
            <Grid size={12}>
              <Button
                sx={{ color: '#fff' }}
                id={'resetbtn_select'}
                className={
                  formNumber === selectedPrimary
                    ? 'btn btn-primary selectbtn selectedQuote'
                    : 'btn btn-primary selectbtn'
                }
                onClick={() => {
                  setSelectedPrimary(formNumber);
                  setPrimaryError(false);
                }}
              >
                {formNumber === selectedPrimary ? 'Selected' : 'Select'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      );
    }

    return totalElements;
  };

  useEffect(() => {
    if (currentId) {
      if (currentId !== 'Add') {
        fetchSingleRecord(currentId);
      }
    } else {
      setCurrentRecord(null);
    }
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      if (contractorList.length === 0) fetchContractors();
      if (billableItems.length === 0) fetchBillables();
      if (resourceTypesList.length === 0) fetchResourceTypes();
      if (unitType.length === 0) fetchUnitTypes();
    }
  }, [currentId]);

  const formFields: FormFieldData[] = [
    {
      name: 'name',
      label: 'Resource Name',
      value: resourceForm.name,
      onChange: handleInputChange,
      isRequired: true,
      size: 12,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Resource name is required' : '')],
    },
    {
      name: 'isQuote',
      label: 'Request for quote',
      value: resourceForm.isQuote,
      onChange: handleInputChange,
      isRequired: false,
      type: 'switchField',
      size: 6,
      validationRules: [],
    },
    {
      name: 'reorderPoint',
      label: 'Reorder Point',
      value: resourceForm.reorderPoint,
      onChange: handleInputChange,
      isRequired: false,
      size: 6,
      type: 'textfield',
      validationRules: [],
    },
    {
      name: 'unitTypeId',
      label: 'Unit of Measure',
      value: resourceForm.unitTypeId,
      onChange: handleInputChange,
      isRequired: true,
      type: 'selectField',
      size: 6,
      options: unitType,
      validationRules: [(value) => (!value ? 'Unit is required' : '')],
    },
    {
      name: 'expiryDate',
      label: 'Expiry Date',
      value: resourceForm.expiryDate,
      onChange: handleExpiryDate,
      isRequired: true,
      type: 'datepicker',
      size: 6,
      validationRules: [(value) => (!value ? 'Expiry date is required' : '')],
      keyname: 'expiryDateResource',
    },
    {
      name: 'resourceTypeId',
      label: 'Resource Type',
      value: resourceForm.resourceTypeId,
      onChange: handleInputChange,
      isRequired: true,
      type: 'selectField',
      size: 6,
      options: resourceTypesList,
      validationRules: [(value) => (!value ? 'Resource type is required' : '')],
    },
    {
      name: 'price',
      label: 'Price',
      value: resourceForm.price,
      onChange: handlePriceChange,
      isRequired: true,
      size: 6,
      type: 'textfield',
      inputType: 'number',
      validationRules: [
        (value) =>
          !value || value == '' || isNaN(value) ? 'Price is required' : '',
      ],
    },
    {
      name: 'contractorId',
      label: 'Contractor/Supplier',
      value: resourceForm.contractorId,
      onChange: handleInputChange,
      isRequired: true,
      type: 'selectField',
      size: 6,
      options: contractorList,
      validationRules: [
        (value) => (!value ? 'Contractor/supplier is required' : ''),
      ],
    },
    {
      onChange: handleBillableChange,
      label: 'Billable Items',
      isRequired: false,
      value: resourceForm.billables,
      name: 'billables',
      options: billableItems,
      type: 'textfieldAutocomplete',
      size: 6,
      validationRules: [],
    },
    {
      onChange: (file: any) => {
        handleFileChange(file, 'resource_product');
      },
      value: resourceForm.id ? s3FilesProduct : [],
      name: 'fileURL',
      isRequired: false,
      label: 'Products Attachment',
      multiple: true,
      type: 'file',
      size: 6,
      existingFiles: s3FilesProductUpdate,
      onRemoveFile: (file: any) => {
        handleRemove(file, 'resource_product');
      },
      onRemoveExistingFile: (file: any) => {
        handleRemoveFileUpdate(file, 'resource_product');
      },
      onOpenFile: (id) => {
        HttpService.handleDownloadFile(id, getAdmin());
      },
    },
    {
      onChange: (file: any) => {
        handleFileChange(file, 'resource_commercial');
      },
      value: resourceForm.id ? s3FilesCommercial : [],
      name: 'fileURLComm',
      isRequired: false,
      label: 'Commercial Attachments',
      multiple: true,
      type: 'file',
      size: 6,
      existingFiles: s3FilesCommercialUpdate,
      onRemoveFile: (file: any) => {
        handleRemove(file, 'resource_commercial');
      },
      onRemoveExistingFile: (file: any) => {
        handleRemoveFileUpdate(file, 'resource_commercial');
      },
      onOpenFile: (id) => {
        HttpService.handleDownloadFile(id, getAdmin());
      },
    },
    {
      isRequired: false,
      label: 'Notes',
      name: 'notes',
      minRows: 7,
      value: resourceForm.notes,
      onChange: handleInputChange,
      size: 12,
      type: 'textareaField',
    },
  ];

  const formFieldsIsQuote: FormFieldData[] = [
    {
      name: 'name',
      label: 'Resource Name',
      value: resourceForm.name,
      onChange: handleInputChange,
      isRequired: true,

      size: 12,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Resource name is required' : '')],
    },
    {
      name: 'isQuote',
      label: 'Request for quote',
      value: resourceForm.isQuote,
      onChange: handleInputChange,
      isRequired: false,
      type: 'switchField',
      checked: resourceForm.isQuote,
      size: 12,
      validationRules: [],
    },
    {
      name: 'unitTypeId',
      label: 'Unit of Measure',
      value: resourceForm.unitTypeId,
      onChange: handleInputChange,
      isRequired: true,
      type: 'selectField',
      size: 6,
      options: unitType,
      validationRules: [(value) => (!value ? 'Unit is required' : '')],
    },
    {
      name: 'expiryDate',
      label: 'Expiry Date',
      value: resourceForm.expiryDate,
      onChange: handleExpiryDate,
      isRequired: true,
      type: 'datepicker',
      size: 6,
      validationRules: [(value) => (!value ? 'Expiry date is required' : '')],
      keyname: 'expiryDateResource',
    },
    {
      name: 'resourceTypeId',
      label: 'Resource Type',
      value: resourceForm.resourceTypeId,
      onChange: handleInputChange,
      isRequired: true,
      type: 'selectField',
      size: 6,
      options: resourceTypesList,
      validationRules: [(value) => (!value ? 'Resource type is required' : '')],
    },
    {
      label: '',
      type: 'custom',
      name: '',
      isRequired: false,
      size: 12,
      onChange: () => {},
      value: '',
      customComponent: (
        <Grid
          container
          spacing={2}
          style={{ width: '100%', textAlign: 'left' }}
        >
          <Grid size={9}>
            <Grid
              container
              spacing={2}
              style={{ width: '100%', textAlign: 'left' }}
            >
              {renderQuotes()}
            </Grid>
            {primaryError && (
              <span className="bad-field mt-3">Select any one from above</span>
            )}
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right' }}>
            <AddCircleOutline
              style={quoteActionStyle}
              onClick={() => {
                setTotalQuotes(totalQuotes + 1);
              }}
            />
            <HighlightOff
              className="ms-2"
              style={quoteActionStyle}
              onClick={() => {
                removeQuoteFields();
              }}
            />
          </Grid>
        </Grid>
      ),
    },
  ];

  return (
    <Stack>
      <CommonForm
        fields={resourceForm.isQuote ? formFieldsIsQuote : formFields}
        onCancel={() => {}}
        formReset={clearForm}
        formTitle={currentId !== 'Add' ? 'Update Resource' : 'Add New Resource'}
        isLoading={loading}
        isUpdate={currentId !== 'Add' ? true : false}
        onSave={resourceForm.isQuote ? handleSaveSpecial : handleSave}
        actionButtonPosition="bottom"
      />

      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Stack>
  );
};

const quoteActionStyle = {
  boxShadow: 'none',
  cursor: 'pointer',
  height: '50px',
};

export default ResourcesForm;
